import {Component, inject, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Subscription} from "rxjs";
import {RouterLink} from "@angular/router";
import {TranslatePipe} from "@ngx-translate/core";
import {Paths} from "../../paths";
import {StateService} from "../../services/state/state.service";
import {nonBlank, unsubscribe} from "../../libs/utils/epic.utils";
import {environment} from "../../../environments/environment";
import {offlineFileUrl} from "../../viewer/offline/viewer-offline";

@Component({
  selector: 'acc-footer',
  imports: [RouterLink, TranslatePipe],
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './footer.component.css'
})
export class FooterComponent implements OnInit, OnDestroy {

  /* Paragraph 5 DDG verlangt "leicht erkennbar, unmittelbar erreichbar und staendig verfuegbar" -
     die Fusszeile ist der einzige Ort in `dash`, der auf jedem Bildschirm steht. */
  protected readonly legalNoticePath: string = '/' + Paths.LEGAL_NOTICE;
  /* Die Uebersicht steht daneben, nicht davor: Paragraph 5 DDG verlangt das Impressum "unmittelbar erreichbar",
     und ein Zwischenschritt ueber eine Sammelseite waere ein Klick mehr, als die Vorschrift zulaesst. */
  protected readonly legalOverviewPath: string = '/' + Paths.LEGAL_OVERVIEW;
  protected readonly isIronBackupViewer: boolean = environment.ironBackupViewer;
  protected readonly year: string = String(new Date().getFullYear());
  protected title: string | undefined;
  protected website: string | undefined;
  protected version: string | undefined;
  /* Der Viewer hat kein Backend, das die Rechtstexte liefert: Er verweist auf Impressum und Datenschutzerklaerung der
     Marke, bei der die Sicherung entstanden ist. Die Uebersicht der Zustimmungen entfaellt dort, sie liegt nicht im Export. */
  protected viewerLoginUrl: string | undefined;
  /* Relativ: dash liegt unter /, der iron-backup-viewer unter /<Fassung>/ - die Datei liegt jeweils daneben (postbuild).
     Die Offline-Fassung hat keine Nachbardatei und zeigt den eingebetteten Text. */
  protected readonly licensesUrl: string = offlineFileUrl('3rdpartylicenses.txt');

  private readonly stateService: StateService = inject(StateService);
  private readonly subs: Subscription[] = [];

  ngOnInit(): void {
    this.subs.push(this.stateService.getInfo().subscribe((i) => {
      this.title = i.name;
      this.website = i.websiteUrl;
      this.version = i.version;
      this.viewerLoginUrl = nonBlank(i.loginUrl) ? i.loginUrl : undefined;
    }));
  }

  ngOnDestroy(): void {
    unsubscribe(this.subs);
  }
}
